<p-tabMenu [model]="items" [(activeItem)]="activeItem" [scrollable]="true" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>
<!-- <div (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')" class="h-full">
    <router-outlet></router-outlet>
</div> -->
<div class="h-full">
    <router-outlet></router-outlet>
</div>